import React from "react";
import styled from "styled-components";
import { TableHeaderColumn } from "components";

export const TableHeader = ({ sortCol, sortType, onSort = () => {} }) => {
  return (
    <Container>
      <TableHeaderColumn label="Name"></TableHeaderColumn>
      <TableHeaderColumn label="Parent Retailer"></TableHeaderColumn>
      <TableHeaderColumn label="Circulars"></TableHeaderColumn>
      <TableHeaderColumn label="Pages"></TableHeaderColumn>
      <TableHeaderColumn label="Issues"></TableHeaderColumn>
      <TableHeaderColumn label="Tiers"></TableHeaderColumn>
      <TableHeaderColumn></TableHeaderColumn>
      <TableHeaderColumn></TableHeaderColumn>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 0 0px 0 32px;
  color: white;
  font-size: ${(props) => props.theme.palette.m};
  margin: 28px 12px 15px 12px;
  & > div:nth-child(1) {
    flex: 1;
  }
  & > div:nth-child(2) {
    width: 300px;
  }
  & > div:nth-child(3) {
    width: 120px;
  }
  & > div:nth-child(4) {
    width: 120px;
  }
  & > div:nth-child(5) {
    width: 140px;
  }
  & > div:nth-child(6) {
    width: 40px;
  }
  & > div:nth-child(7) {
    width: 130px;
  }
`;
